import BottomSheet from '@/components/shared/bottom-sheet/bottom-sheet.component';
import Typography from '@/components/shared/typography/typography.component';
import { useTranslation } from '@/hook';
import Image from 'next/image';

import { BookingWhiteCallIcon } from 'public/Images';
import { FC } from 'react';

interface SylndrCallsBottomSheetProps {
    open: boolean;
    closeModal: () => void;
}

const SylndrCallsBottomSheet: FC<SylndrCallsBottomSheetProps> = ({
    open,
    closeModal,
}) => {
    const { t } = useTranslation();
    return (
        <BottomSheet open={open} setOpen={closeModal}>
            <div className="h-max bg-white flex-col flex rounded-2xl">
                <div
                    className="w-full flex items-center justify-center py-3"
                    onClick={closeModal}
                >
                    <div className="bg-gray-300 h-1 w-20 rounded-[100px]" />
                </div>
                <div className="flex justify-between items-center py-4 ">
                    <Typography
                        variant="subtitle2SemiBold"
                        className="!text-gray-800"
                    >
                        {t('sylndrHotline')}
                    </Typography>
                    <Typography
                        variant="subtitle2SemiBold"
                        className="!text-primary-700"
                    >
                        17188
                    </Typography>
                </div>
                <div className="w-full p-2 bg-gray-50  border border-gray-200 rounded-md">
                    <Typography className="!text-[10px] !text-gray-600 !font-normal">
                        {t('customerService')}
                    </Typography>
                </div>
                <div className="py-3  W-full border-t-gray-200 border-t px-4 ar:translate-x-4 en:-translate-x-4 !w-screen mt-3">
                    <a
                        href="tel:17188"
                        className="flex justify-center items-center gap-2 !w-full bg-primary-600 rounded-lg h-12 "
                    >
                        <Image
                            src={BookingWhiteCallIcon}
                            width={18}
                            alt="navigator"
                        />
                        <Typography
                            variant="body2Medium"
                            className="!text-white ar:mt-1"
                        >
                            {t('call')}
                        </Typography>
                    </a>
                </div>
            </div>
        </BottomSheet>
    );
};

export default SylndrCallsBottomSheet;
